import React from 'react';
import styled from 'styled-components/macro';
import { ResourceStrings } from '../../../ResourceStrings';
import { Icon } from '@fluentui/react/lib/Icon';
import Button from '../../shared/Button';

export default function RefreshButton({ disabled, onClick }: { disabled?: boolean; onClick: () => void }): JSX.Element {
    return <RefreshButtonWrapper buttonType="link" disabled={disabled} onClick={onClick}>
        <Icon iconName="SyncStatus" />
        <span>{ResourceStrings.refresh()}</span>
    </RefreshButtonWrapper>
}

const RefreshButtonWrapper = styled(Button)`
    padding: 0;
    height: 2.8rem;

    span {
        margin-left: 0.6rem;
        color: var(--color-on-background);
    }
`;
